<div class="flex flex-wrap justify-content-between mb-4">
  <h3 class="flex align-items-center">Αρχική</h3>
</div>

<div class="flex justify-content-center w-full">
  <div class="flex flex-column gap-6 justify-content-center w-9 mt-6">
    <div class="flex flex-column gap-2 align-items-center">
      <div class="text-lg font-semibold">
        Καλώς ορίσατε στην εφαρμογή Απογευματινά Χειρουργεία της Ε.Κ.Α.Π.Υ.
      </div>
      <div class="text-lg">
        Επιλέξτε μία απο τις διαθέσιμες λειτουργίες της εφαρμογής
      </div>
    </div>

    <div class="flex flex-wrap gap-4">
      <ng-container *ngFor="let item of getMenuItems()">
        @if (isTileButtonVisible(item)) {
        <app-tile-button
          [icon]="item.icon"
          [label]="item.label"
          (click)="onButtonClick(item)"
        />
        }
      </ng-container>
    </div>
  </div>
</div>
